export default "__VITE_ASSET__CaMLL5qc__"